import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useContext, useState, useEffect } from 'react';
import { PlayerTimeContext, usePlayerCurrentTime, usePlayerTime } from '@dtvgo/player-context';
import { ScheduleContext } from './contexts.js';

var DELAYED_SECONDS = 5;
function isDelayed(timeShift) {
  return Math.abs(timeShift) > DELAYED_SECONDS;
}
function useIsDelayed() {
  var isLive = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
  // use the time shift store instead of value because we don't want to render everytime the
  // time shift changes but only when the derivated delayed state changes
  var timeShiftValueStore = useContext(PlayerTimeContext);
  var _useState = useState(isLive && isDelayed(timeShiftValueStore.get())),
    _useState2 = _slicedToArray(_useState, 2),
    delayed = _useState2[0],
    setDelayed = _useState2[1];
  useEffect(function () {
    return isLive ? timeShiftValueStore.onChange(function (timeShift) {
      setDelayed(isDelayed(timeShift));
    }) : undefined;
  }, [isLive, timeShiftValueStore]);
  return delayed;
}
function useLiveDuration() {
  var _useContext = useContext(ScheduleContext),
    startTime = _useContext.startTime,
    endTime = _useContext.endTime;
  return (endTime - startTime) / 1000;
}
function useLiveEdgeProgress() {
  var _useContext2 = useContext(ScheduleContext),
    startTime = _useContext2.startTime;
  // Here we use the value and not the store because every time the current time changes
  // the live edge progress will also change, so it doesn't make sense to make the logic more
  // complex to achieve nothing
  var currentTime = usePlayerCurrentTime();
  var liveEdgeProgress = currentTime - startTime / 1000;
  return liveEdgeProgress;
}
function useLiveProgress() {
  var liveEdgeProgress = useLiveEdgeProgress();
  // Same thing here as in useLiveEdgeProgress
  var timeShift = usePlayerTime();
  return liveEdgeProgress + timeShift;
}

export { useIsDelayed, useLiveDuration, useLiveEdgeProgress, useLiveProgress };
//# sourceMappingURL=hooks.js.map
